import { merchantIcons } from '@assets/icons';
import { ROUTE_PATHS } from '@config/routes';
import { memo } from 'react';
import { useNavigate } from 'react-router';

const AuthBackButton = memo(({ to = ROUTE_PATHS.LOGIN, label = 'Go back' }) => {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() => navigate(to)}
      aria-label={label}
      className="mb-1 flex icon-lg cursor-pointer items-center justify-center transition-opacity hover:opacity-70"
    >
      <img src={merchantIcons.arrowLeft} alt="" className="icon-lg" aria-hidden="true" />
    </button>
  );
});

AuthBackButton.displayName = 'AuthBackButton';

export default AuthBackButton;
